import { Route, Routes } from "react-router";
import { NotFound } from "../../../app/pages/NotFound";
import { WILDCARD_ROUTE } from "../../../common/constants";
import { TopAgentType } from "../../../common/enums";
import { Permission } from "../../../common/security/enums";
import PageWithPermission from "../../auth/components/PageWithPermission";
import { CommissionPromotionsContainer } from "./containers/CommissionPromotionsContainer";

export const routes = () => (
  <Routes>
    <Route
      index
      element={
        <PageWithPermission
          component={<CommissionPromotionsContainer />}
          permissions={[Permission.TOP_AGENT_COMMISSIONS, Permission.AGENT_COMMISSIONS_SETTINGS]}
          allowedTopAgents={[TopAgentType.PLUS]}
        />
      }
    />

    <Route path={WILDCARD_ROUTE} element={<NotFound />} />
  </Routes>
);
